
<mat-card class="improvement-needed" *ngIf="item.status == 'checked-out'">
    <mat-card-header>
        <mat-card-title>Item checked out</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="dont-break-out">{{item.checkedOutReason}}</div>
    </mat-card-content>
    <mat-card-actions>
    </mat-card-actions>
</mat-card>

<mat-card class="improvement-needed" *ngIf="item.improvementRequest != ''">
    <mat-card-header>
        <mat-card-title>Improvement Needed</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="dont-break-out">{{item.improvementRequest}}</div>
    </mat-card-content>
    <mat-card-actions>
        <button (click)="markImprovementDone()" mat-flat-button color="accent" mat-button>Mark Done</button>
      </mat-card-actions>
</mat-card>